export const VOICE_SPEED_OPTIONS = Object.freeze([
  Object.freeze({ value: 1, label: 'Normal' }),
  Object.freeze({ value: 0.9, label: 'A little slower' }),
  Object.freeze({ value: 0.8, label: 'Slower' }),
  Object.freeze({ value: 0.7, label: 'Extra slow' }),
]);

export function normalizeVoiceSpeed(value) {
  const numeric = Number(value);
  return VOICE_SPEED_OPTIONS.some((option) => option.value === numeric) ? numeric : 1;
}

export function isSupportedVoiceSpeed(value) {
  const numeric = Number(value);
  return VOICE_SPEED_OPTIONS.some((option) => option.value === numeric);
}

export function applyPitchPreservingSpeed(element, value) {
  const speed = normalizeVoiceSpeed(value);
  if (!element) return speed;
  element.defaultPlaybackRate = speed;
  element.playbackRate = speed;
  if ('preservesPitch' in element) element.preservesPitch = true;
  if ('webkitPreservesPitch' in element) element.webkitPreservesPitch = true;
  if ('mozPreservesPitch' in element) element.mozPreservesPitch = true;
  return speed;
}
